import { render, staticRenderFns } from "./SellerForm.vue?vue&type=template&id=02538db6&"
import script from "./SellerForm.vue?vue&type=script&lang=js&"
export * from "./SellerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports